import RaisedButton from 'material-ui/RaisedButton';
import React, { Component } from 'react';
import './App.css';
import NavMenu from './NavMenu.js'


var athleteWarrior = [
    '../videos/athleteWarrior/AthleteWarrior-2018-01-21-Bars.mp4',
    '../videos/athleteWarrior/AthleteWarrior-2018-01-21-Beam.mp4',
    '../videos/athleteWarrior/AthleteWarrior-2018-01-21-Floor.mp4',
    '../videos/athleteWarrior/AthleteWarrior-2018-01-21-Vault.mp4'
];

var motorCity = [
    '../videos/motorCity/MotorCityClassic-2018-02-11-Bars.mp4',
    '../videos/motorCity/MotorCityClassic-2018-02-11-Beam.mp4',
    '../videos/motorCity/MotorCityClassic-2018-02-11-Floor.mp4',
    '../videos/motorCity/MotorCityClassic-2018-02-11-Vault.mp4'
];

var wildFire = [
    '../videos/wildFire/WildFireChallenge-2018-02-25-Bars.mp4',
    '../videos/wildFire/WildFireChallenge-2018-02-25-Beam.mp4',
    '../videos/wildFire/WildFireChallenge-2018-02-25-Floor.mp4',
    '../videos/wildFire/WildFireChallenge-2018-02-25-Vault.mp4'
];

class Video extends Component {

    componentWillMount() {
        this.setState({
            videoId: 0,
            source: athleteWarrior,
            compTitle: "Athlete Warrior Fun Meet"
        })
    }

    setSource = (vidSource, event) => {
        var title;

        if (vidSource === "athleteWarrior") {
            vidSource = athleteWarrior
            title = "Athlete Warrior Fun Meet"
        }

        if (vidSource === "motorCity") {
            vidSource = motorCity
            title = "Motor City Classic"
        }

        if (vidSource === "wildFire") {
            vidSource = wildFire
            title = "Wild Fire Challenge"
        }

        this.setState({
            source: vidSource,
            compTitle: title,
            videoId: event
        },
            this.reloadVideo);
            this.showVideo(event);
    }

    showVideo = (id) => {
        this.setState({
            videoId: id
        }, this.reloadVideo);
    }

    reloadVideo = () => {
        this.refs.video.load();
        this.refs.video.play();
    }
  
      render() {
        return (
            <div>
                {(this.props.isAuthenticated) ?
                    <div>
                        <NavMenu compTitle={this.state.compTitle} setSource={(vidSource, event) => this.setSource(vidSource, event)} />
                        <div className="center-align">
                            <div className="row">
                                <video className="video" controls loop ref="video">
                                    <source src={this.state.source[this.state.videoId]} type="video/mp4" />
                                </video>
                            </div>
                            <div className="row">
                                <a href={this.state.source[this.state.videoId]} download><RaisedButton label="Download this Video" /></a>
                            </div>
                        </div>
                    </div>
                    : (<div className="center-align"> You are not authorized to see this page </div>)}
            </div>
        );
    }
}

export default Video;



// WEBPACK FOOTER //
// ./src/Video.js